import memoizee from 'memoizee';

export const memoize = <A extends Array<unknown>, R>(func: (...args: A) => R) =>
    memoizee(func, {
        normalizer: (args) => JSON.stringify(args),
        primitive: true,
    });

export const primitiveMemoize = <A extends Array<unknown>, R>(func: (...args: A) => R) =>
    memoizee(func, {
        primitive: true,
    });
